import type { MentionCandidate } from "./MentionCandidate";
import { formatMention } from "./formatMention";
import { pendingMention } from "./pendingMention";

/**
 * 書きかけの `@…` を、選んだ候補の表記へ置き換える。
 *
 * 書きかけが無ければ `null` を返す。**入力欄を経由しない書き換えでも同じ結果を作れるように、
 * 純粋関数として外へ出してある。** 状態を持つのはキャレットだけで、それも引数と戻り値に置く。
 *
 * **置き換えるのは `@` からキャレットまで。** 末尾まで置き換えると、文の途中に足したときに
 * 後ろの本文が消える（記録 23）。
 *
 * 表記の後ろへ空白を 1 つ足す。続けて文を書けるようにするためで、キャレットもその後ろへ置く。
 * 戻さないと挿し込んだ文字列の中にキャレットが残る。
 */
export function insertMention(
    text: string,
    caret: number,
    candidate: MentionCandidate
): { text: string; caret: number } | null {
    const pending = pendingMention(text, caret);
    if (pending === null) return null;
    const mention = `${formatMention(candidate.name, candidate.ref)} `;
    return {
        text: text.slice(0, pending.at) + mention + text.slice(caret),
        caret: pending.at + mention.length,
    };
}
